import Vue from "vue";
import Router from "vue-router";
import Index from "@/page/index";
import About from "@/page/about";
import Service from "@/page/service";
import Function from "@/page/function";
import Contact from "@/page/contact";
import Stage from "@/page/stage";
import Media from "@/page/media";
import News from "@/page/news";
import Event from "@/page/event";
import MediaFile from "@/page/mediaFile";
import ImgFile from "@/page/imgFile";
import NewsText from "@/page/newsText";
import Theme from "@/page/theme";
import MoreNews from "@/page/moreNews";
import View from "@/page/view";
import ImgText from "@/page/imgText";
import ViewDetail from "@/page/viewDetail";
import CampDetail from "@/page/campDetail";
import PlayDetail from "@/page/playDetail";
import ScenicDetail from "@/page/scenicDetail";
import ThemeDetail from "@/page/themeDetail";
import Activity from "@/page/activity";
Vue.use(Router);

export default new Router({
  // mode: 'history',
  // base: '',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index
    },
    {
      path: "/about",
      name: "About",
      component: About
    },
    {
      path: "/service",
      name: "Service",
      component: Service
    },
    {
      path: "/function",
      name: "Function",
      component: Function
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact
    },
    {
      path: "/stage",
      name: "Stage",
      component: Stage
    },
    {
      path: "/media",
      name: "Media",
      component: Media
    },
    {
      path: "/news",
      name: "News",
      component: News
    },
    {
      path: "/event",
      name: "Event",
      component: Event
    },
    {
      path: "/mediaFile",
      name: "MediaFile",
      component: MediaFile
    },
    {
      path: "/imgFile",
      name: "ImgFile",
      component: ImgFile
    },
    {
      path: "/newsText",
      name: "NewsText",
      component: NewsText
    },
    // {
    //   path: "/theme",
    //   name: "Theme",
    //   component: Theme
    // },
    {
      path: "/moreNews",
      name: "MoreNews",
      component: MoreNews
    }, {
      path: "/view",
      name: "View",
      component: View
    }, {
      path: "/imgText",
      name: "ImgText",
      component: ImgText
    }, {
      path: "/viewDetail",
      name: "ViewDetail",
      component: ViewDetail
    }, {
      path: "/campDetail",
      name: "CampDetail",
      component: CampDetail
    }
    , {
      path: "/playDetail",
      name: "PlayDetail",
      component: PlayDetail
    }
    , {
      path: "/scenicDetail",
      name: "ScenicDetail",
      component: ScenicDetail
    }
    , {
      path: "/themeDetail",
      name: "ThemeDetail",
      component: ThemeDetail
    }, {
      path: "/activity",
      name: "Activity",
      component: Activity
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js